import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { getExternalProps } from "./utils/getExternalProps.js";
import { loadAndActivateI18n } from "./utils/i18n.js";

const el = document
	.querySelector("aurora-mobility-recommendations-podlet-isolated")!
	.shadowRoot!.querySelector("#aurora-mobility-recommendations-podlet-content")!;

const root = createRoot(el);
const props = getExternalProps();

if (!props) {
	throw new Error("External props not found");
}

loadAndActivateI18n(props?.locale);

root.render(<App {...props} />);
